export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/business_cards_stationery.c4f02ec.svg";